module.exports = require("lodash/get");


//////////////////
// WEBPACK FOOTER
// external "lodash/get"
// module id = 7
// module chunks = 0